<template>
  <v-container class="pa-0 fill-height" fluid>
    <!-- Snackbar para errores -->
    <SnackbarMessage ref="snackbar" />

    <!-- Layout de carga -->
    <LoadingLayout v-if="isLoading">
      <CircularLoading>
        Iniciando sesión
      </CircularLoading>
    </LoadingLayout>
    <!-- Contenido principal -->
    <v-container v-else class="fill-height" fluid>
      <!-- Fila para el contenido -->
      <v-row no-gutters align="center" justify="center" class="custom-height">
        <!-- Columna para la tarjeta -->
        <v-col cols="11" md="6">
          <!-- Tarjeta -->
          <v-card class="form-card mt-8 mb-8">
            <!-- Título -->
            <v-card-text>
              <!-- Título -->
              <p
                class="headline font-weight-black text-center black--text mb-0"
              >
                ¡Bienvenid@ 🙂!
              </p>
              <!-- Subtítulo -->
              <p class="title font-weight-regular text-center black--text">
                Gracias por usar Deltia
              </p>
            </v-card-text>
            <!-- Contenedor para los inputs -->
            <v-container>
              <v-layout align-center justify-center wrap>
                <!-- Email -->
                <v-flex xs11 md8>
                  <TextField
                    class="mb-5 mt-5"
                    placeholder="Escribe tu email"
                    type="email"
                    name="username"
                    v-model="email"
                  />
                </v-flex>
                <!-- Contraseña -->
                <v-flex xs11 md8>
                  <TextField
                    class="mb-10"
                    placeholder="Escribe tu contraseña"
                    type="password"
                    name="password"
                    v-model="password"
                  />
                </v-flex>
                <!-- Botón -->
                <v-flex xs11 md8>
                  <PrimaryButton class="mb-5 mt-5" @click="signIn">
                    Inicia sesión
                  </PrimaryButton>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
/* eslint-disable prettier/prettier */
// Importar componentes
import LoadingLayout from "@/layouts/LoadingLayout";
import CircularLoading from "@/components/Loading/Circular";
import TextField from "@/components/TextField";
import PrimaryButton from "@/components/PrimaryButton";
import SnackbarMessage from "@/components/SnackbarMessage";

// Importar acciones
import { SIGN_IN_REQUEST } from "@/store/actions/auth";
import { mapGetters } from "vuex";

export default {
  name: "sign-in",
  components: {
    LoadingLayout,
    CircularLoading,
    TextField,
    PrimaryButton,
    SnackbarMessage
  },
  data() {
    return {
      email: "",
      password: "",
      isLoading: false
    };
  },
  methods: {
    signIn: async function() {
      // Asegurarse de que los campos están completos
      const areFieldsComplete = this.checkFields();

      // Verificar que los campos estén completos
      if (!areFieldsComplete) {
        // Mostrar error
        this.$refs.snackbar.showError("Por favor rellena todos los campos");
        return;
      }

      // Mostrar spinner
      this.isLoading = true;

      // Crear usuario
      const user = {
        email: this.email,
        password: this.password
      };

      try {
        // Iniciar sesión usando vuex
        const { profile } = await this.$store.dispatch(SIGN_IN_REQUEST, user);

        // Autenticar usuario con mixpanel
        this.$mixpanel.identify(this.getProfile.business_id);

        // Ocultar spinner
        this.isLoading = false;

        // Obtener primera pestaña
        const { key: firstTab } =
          profile.tabs && profile.tabs?.length > 0
            ? this.getMenuItems.find(item => profile.tabs.includes(item.key))
            : { key: "settings" };

        // Ir a la primera pestaña
        if (profile.user_type === "employee") {
          this.$router.replace({ name: firstTab });
        } else {
          this.$router.replace({ name: "dashboard" });
        }
      } catch (err) {
        // Ocultar spinner
        this.isLoading = false;

        // Mostrar error
        this.$refs.snackbar.showError(err.message);
      }
    },
    checkFields: function() {
      return !!this.email && !!this.password;
    }
  },
  computed: {
    ...mapGetters(["getProfile", "getMenuItems"])
  }
};
</script>

<style scoped>
.custom-height {
  min-height: calc(100vh - 83px) !important;
}

.form-card {
  background-color: white;
  border-radius: 10px !important;
  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.1);
  min-height: 13vh;
}
</style>
